import * as React from 'react';
import { FC  } from 'react';
import { v4 as uuidv4 } from "uuid";
import RecipePageStarRatingStaticStar from './components/StarRatingStaticStar'
interface RecipePageStarRatingStaticModel {
    contentId: string
}

interface Rating {
    averageRating: number,
    numberOfRatings: number
}

const RecipePageStarRatingStatic: FC<RecipePageStarRatingStaticModel> = (props) => {

    const [rating, setRating] = React.useState<Rating>({
        averageRating: 0,
        numberOfRatings: 0,
    });
    const [loading, setLoading] = React.useState(true);

    const getStarValue = async () => {
        try {
            const url = `/api/recipes/getratingsummary/${props.contentId}`;
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setRating(data);
            setLoading(false);
        } catch (error) {
            console.error('Failed to fetch rating:', error);
        }
    };

    React.useEffect(() => {
        getStarValue();
    }, []);

    return (
        <>
            {!loading && (
                <ul className="flex justify-center items-center laptop:justify-start">
                    {Array.from({ length: 5 }, (_, i) => (
                        <li key={uuidv4()}>
                            <RecipePageStarRatingStaticStar starValue={rating.averageRating} starIndex={i}  key={uuidv4()}/>
                        </li>
                    ))}
                    <li className='mx-1 font-semibold text-lg laptop:text-xl'>
                        {rating.averageRating}
                    </li>
                    <li className='mx-1 text-sm laptop:text-base text-black-text'>
                        ({rating.numberOfRatings})
                    </li>
                </ul>
            )}    
        </>

    );
};
export default RecipePageStarRatingStatic;